<template>
  <div class="map-container">
    <div class="top-bar">
      <div class="title">{{ title }}</div>
    </div>
    <div class="map" id="map"></div>
    <meteo
      :viewer="viewer"
      ref="meteo"
      :isRotation="isRotation"
      :changeRotation="changeRotation"
      :clientWidth="clientWidth"
      :lonlat="lonlat"
    ></meteo>
    <Ship
      ref="Ship"
      :viewer="viewer"
      :hoverMmsi="hoverMmsi"
      :aisShipList="aisShipList"
      :clientWidth="clientWidth"
      :allGroupListData="allGroupListData"
      :currentNoonData="currentShipData.noon_report"
      :clientHeight="clientHeight"
    ></Ship>
    <div class="lng-lat-box" :class="showWeatherIcons ? 'lng-lat-up' : ''">
      <b v-if="lngLatHover && lngLatHover.lon"
        >LON: {{ lngLatHover.lon.toFixed(4) }}</b
      >
      <br />
      <b v-if="lngLatHover && lngLatHover.lat"
        >LAT: {{ lngLatHover.lat.toFixed(4) }}</b
      >
    </div>
    <div class="warn">
      <warn-list :viewer="viewer" :clientWidth="clientWidth"></warn-list>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import CustomCesium from '@/utils/custom-cesium'
import Meteo from "./meoto.vue";
import Ship from "./ship.vue";
import { Rotation } from "../../utils/rotation";
import { mapGetters, mapActions } from "vuex";
import WarnList from './warnlist.vue'

export default defineComponent({
  name: "MapBar",
  components: { Meteo, Ship, WarnList },
  props: {
    aisShipList: {
      type: Array,
      default: () => {
        return null;
      },
    },
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    currentShipData: {
      type: Object,
      default: () => {
        return null;
      },
    },allGroupListData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    clientHeight: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      // title: "九方NIO船舶调度指挥平台",
      title: "山东海运股份有限公司",
      viewer: {},
      countryLabelEntity: [],
      globalEntities: [],
      isRotation: false,
      Rotation: null,
      timer: null,
      lonlat: [],
      lngLatHover: {},
      hoverMmsi: "",
    };
  },
  mounted() {
    this.initMap();

    // 1小时更新一次气象、台风数据
    this.timer = setInterval(() => {
      this.$refs.Typhoon.unpdateTyphoons();
      this.$refs.Ship.unpdateShipsAndLines();
      this.$refs.Weather.updateWeatherLayer();
    }, 1 * 3600 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapGetters(["showWeatherIcons"]),
    clientWidthScale() {
      return this.clientWidth / 1000;
    },
  },
  methods: {
    ...mapActions(['SET_AIS_POINT']),
    initMap() {
      const mapViewer = new CustomCesium('map', {
        clientWidthScale: this.clientWidthScale
      });

      mapViewer.once('load', () => {
        this.handlerMouseEvent(mapViewer)
      })

      this.viewer = mapViewer
      this.$emit('setViewer', mapViewer)
    },
    changeRotation(viewer) {
      if (!this.Rotation) {
        this.Rotation = new Rotation(viewer, { p: 0.1 });
      }
      this.isRotation = !this.isRotation;
      if (this.isRotation) {
        this.Rotation.start();
      } else {
        this.Rotation.stop();
        this.Rotation = null;
        // this.$router.go(0) // 刷新页面
      }
    },
    // 监听事件
    handlerMouseEvent(viewer) {

      viewer.on('mapChangeStart', event => {
        this.$refs.meteo.clearWeather()
      })

      viewer.on('mapChange', event => {
        this.$refs.meteo.resetWeather(event.mapType)
      })

      viewer.on('mousemove', event => {
        let lnglat = event.lngLat
        if(!lnglat) return
        this.lngLatHover = {
          lon: lnglat.lng,
          lat: lnglat.lat
        }
      })
      
      viewer.on('click', event => {
        let {lng, lat} = event.lngLat
        this.lonlat = [lng, lat]
        const pick = viewer.pick(event.position)
        const tmp = new Date().getTime()
        if (pick && pick.id) {
          if (pick.id._name === "ship") {
            const mmsi = pick.id._id;
            this.$store.dispatch("SET_MMSI", mmsi);
            this.$emit('closePlay', mmsi)
          }else if(pick.id.indexOf('ais_point') > -1) {
            this.SET_AIS_POINT(pick.primitive.attr)
          }
        }
      })
      
      viewer.on('dbclick', event => {
        const pick = viewer.pick(event.position);
        if (!pick || !pick.id) {
          this.changeRotation(viewer);
        }
      })
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../styles/variables";

@media screen and (max-width: 1920px) {
  .map-container {
    height: 100%;
    width: 100%;

    .top-bar {
      height: $header-height-1920;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../../assets/png/header-bg-1920.png") center center
        no-repeat;
      background-size: cover;

      .title {
        flex: 1;
        line-height: $header-height-1920;
        color: white;
        font-size: $header-fontsize-1920;
        font-weight: bold;
        text-align: center;
      }

      .icons {
        width: $icons-width-1920;
        height: $header-height-1920;
        line-height: $header-height-1920;
        /* padding-right: 50px; */
        display: flex;
        justify-content: flex-end;
      }
    }

    .map {
      /* margin-top: $header-height-1920; */
      height: calc(100% - $header-height-1920);
      width: 100%;
    }

    .lng-lat-box {
      position: absolute;
      left: 25%;
      bottom: 0;
      min-width: 100px;
      height: 40px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      font-size: 12px;
      text-align: left;
    }

    .link-2d-box {
      position: absolute;
      right: 25%;
      bottom: 0;
      min-width: 100px;
      height: 40px;
      line-height: 40px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #63defe;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      border-radius: 5%;
      cursor: pointer;
    }

    .lng-lat-up {
      bottom: 40px !important;
    }

    .warn {
      position:absolute;bottom: 50px;right: 25vw;
    }
  }
}

@media screen and (min-width: 1921px) {
  .map-container {
    height: 100%;
    width: 100%;

    .top-bar {
      position: absolute;
      top: 0;
      right: 0;
      height: $header-height-2560;
      width: 100%;
      /* margin-right: 50px; */
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../../assets/png/header-bg-1920.png") center center
        no-repeat;
      background-size: cover;

      .title {
        flex: 1;
        line-height: $header-height-2560;
        color: white;
        font-size: $header-fontsize-2560;
        font-weight: bold;
        text-align: center;
      }

      .icons {
        width: $icons-width-2560;
        height: $header-height-2560;
        line-height: $header-height-2560;
        display: flex;
        justify-content: flex-end;

        .icon {
          cursor: pointer;
          padding: 0 12px;
          color: white;
        }
      }
    }

    .map {
      margin-top: $header-height-2560;
      height: calc(100% - $header-height-2560);
      width: 100%;
    }

    .lng-lat-box {
      position: absolute;
      left: 26%;
      bottom: 0;
      min-width: 160px;
      height: 60px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      font-size: 20px;
      text-align: left;
    }

    .lng-lat-up {
      bottom: 60px !important;
    }

    .warn {
      position:absolute;bottom: 50px;right: 26vw;
    }
  }
}

@media screen and (min-width: 2561px) {
  .map-container {
    height: 100%;
    width: 100%;

    .top-bar {
      position: absolute;
      top: 0;
      right: 0;
      height: $header-height-4368;
      width: 100%;
      /* margin-right: 50px; */
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../../assets/png/header-bg-1920.png") center center
        no-repeat;
      background-size: cover;

      .title {
        flex: 1;
        line-height: $header-height-4368;
        color: white;
        font-size: $header-fontsize-4368;
        font-weight: bold;
        text-align: center;
      }

      .icons {
        width: $icons-width-4368;
        height: $header-height-4368;
        line-height: $header-height-4368;
        display: flex;
        justify-content: flex-end;

        .icon {
          cursor: pointer;
          padding: 0 12px;
          color: white;
        }
      }
    }

    .map {
      margin-top: $header-height-6720;
      height: calc(100% - $header-height-6720);
      width: 100%;
    }

    .lng-lat-box {
      position: absolute;
      left: 26%;
      bottom: 0;
      min-width: 300px;
      height: 80px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      font-size: 30px;
      text-align: left;
    }

    .lng-lat-up {
      bottom: 80px !important;
    }
  }
}

@media screen and (min-width: 6700px) {
  .map-container {
    height: 100%;
    width: 100%;

    .top-bar {
      position: absolute;
      top: 0;
      right: 0;
      height: $header-height-6720;
      width: 100%;
      /* margin-right: 50px; */
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../../assets/png/header-bg-6720.png") center center
        no-repeat;
      background-size: cover;

      .title {
        flex: 1;
        line-height: $header-height-6720;
        color: white;
        font-size: $header-fontsize-6720;
        font-weight: bold;
        text-align: center;
      }

      .icons {
        width: $icons-width-6720;
        height: $header-height-6720;
        line-height: $header-height-6720;
        display: flex;
        justify-content: flex-end;

        .icon {
          cursor: pointer;
          padding: 0 5px;
          color: white;
        }
      }
    }

    .map {
      margin-top: $header-height-6720;
      height: calc(100% - $header-height-6720);
      width: 100%;
    }
  }
}

.cesium-viewer-bottom {
  display: none !important;
}
</style>
